<template>
    <div class="player-info" v-if="currentStream">
        <div class="player-info__episode" v-html="currentStream.episode"></div>
        <div class="player-info__show">
            <span v-html="currentStream.name"></span><span v-show="currentStream.presenter"> - met <span v-html="currentStream.presenter"></span></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "StreamInfo",
    computed: {
        currentStream(){ return this.$store.state.player.stream; },
    },
}
</script>

<style lang="scss">
    .player-info {
        margin: 2rem 0 .5rem;

        &__episode {
            margin: 0 0 .5rem;
            font-size: 1.125rem;
            color: $c-black-100;
            text-align: center;
            line-height: 1;
            font-weight: bold;
        }

        &__show {
            font-size: .75rem;
            text-align: center;
        }
    }
</style>